<template>
    <select v-if="visible" v-model="rewrittableValue" :disabled="ro" :class="[ clazz, errorClass ]" :style="style" v-bind="attrs">
        <option v-if="sel.emptyItem" :value="sel.emptyItem.value">{{ sel.emptyItem.name }}</option>
        <option v-for="li in listItems" :value="li.value">{{ li.name }}</option>
        <option v-if="unlisted && !hasRewrite" :value="unlistedValue">
            {{ unlistedName }}
        </option>
    </select>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "./Editor";
import {computed, watch} from "vue";
import {injectExecute} from "../PartInjectKeys";
import type {Select} from "@t/fd/editor/Select";
import {Input} from "@t/fd/editor/Input";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const sel = computed<Select>(() => props.part as Select);
const {visible, value, clazz, errorClass, style, ro, listItems, dataToScreen, localData, tabindexBinding} = useEditor(props);
const hasRewrite = computed(() => typeof sel.value.rewriteUnlisted !== "undefined");
const rewrittableValue = computed({
    get(): any {
        if (unlisted.value && hasRewrite.value) return sel.value.rewriteUnlisted;
		if (sel.value.emptyItem && !value.value) return dataToScreen(sel.value.emptyItem.value);
        return value.value;
    },
    set(v:any) {
        value.value = v;
    }
});

const unlisted = computed(() => {
    const val = value.value; // is converted to string for screen display
    const lst = listItems.value;
    for (let li of lst) {
        const lval = dataToScreen(li.value);
        if (val === lval) return false; // found in the list
    }
    if (sel.value.emptyItem) {
        if (val === dataToScreen(sel.value.emptyItem.value)) return false;
    }
    return true;
});

const unlistedValue = computed(() => {
    if (value.value == null) return "";
    return value.value;
});

const unlistedName = computed(() => {
    if (value.value == null) return "";
    return "(" + value.value + ")";
});

if (sel.value.onChange) {
    const execute = injectExecute();
    watch(() => value.value, (n, o) => {
        if (sel.value.onChange) execute(sel.value.onChange, localData.value, sel.value, n, o);
    });
}

const attrs = computed(() => {
	const a:any = tabindexBinding();
	if (typeof sel.value.autocomplete === "string") a.autocomplete = sel.value.autocomplete;
	return a;
});

</script>

<style>
</style>
